import React from 'react'
import { Direction, DirectionFormat } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { getEnumValues, makeDirectionHelper, makeReversedDirectionHelper } from 'model'

export interface ReversedDirectionSelectboxProps extends Omit<SelectboxProps<Direction, Direction>, 'optionKeys'> {
  directionFormat: DirectionFormat
  reversed: boolean
}

export const ReversedDirectionSelectbox = React.forwardRef((props: ReversedDirectionSelectboxProps, ref: React.Ref<Selectbox>) => {
  const optionKeys = getEnumValues(Direction as any)
  const DirectionHelper = props.reversed ? makeReversedDirectionHelper(props.directionFormat) : makeDirectionHelper(props.directionFormat)
  return <Selectbox ref={ref} optionKeys={optionKeys} getOptionText={DirectionHelper.getName} {...props} />
})

export const ReversedDirectionSelectboxField = Field(ReversedDirectionSelectbox)
